import { useEffect, useState } from "react";

import i18next from "i18next";

import { useBlogSelectors } from "../store/blog/blog.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useGetOtherBlogArticle = () => {
  const [isMounted, setIsMounted] = useState(false);

  const lang = i18next.language;
  const { getBlogContent } = useDispatchedActions();
  const { isBlogDataLoaded } = useBlogSelectors();

  const params = {
    page: 0,
    size: 10,
    tab: "all",
    sortDirection: "desc",
    languageCode: lang,
  };

  useEffect(() => {
    if (!isBlogDataLoaded) {
      getBlogContent(params);
    }
  }, [isBlogDataLoaded]);

  useEffect(() => {
    if (isMounted) {
      getBlogContent(params);
    } else {
      setIsMounted(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);
};
